import React from 'react'
import Album from './Album'

export default function GallerySection({translate, showMediaData, handleHorseMedia}) {
    return (
        <div className="col-md-12 rtl">
            <div className="row">
                <h2>{translate("web.mediaGallery", "Media Gallery")}</h2>
                <div className="col-md-12">
                    {showMediaData.map((item) => (
                        <Album key={'Album'} isShowDetailsPage={true} item={item} handleClick={handleHorseMedia} />
                    ))}
                </div>
            </div>
        </div>
    )
}
